function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var it = /*#__PURE__*/function () {
  function it(t, e) {
    _classCallCheck(this, it);

    this.database = t, this.vd = e, this.parent = "undefined" == typeof window ? self : window, this.database = t, this.vd = e;
  }

  _createClass(it, [{
    key: "Dd",
    value: function Dd() {
      if ("indexedDB" in this.parent) return this.parent.indexedDB;
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      var t;

      try {
        if (null == this.Dd()) return !1;
        {
          var e = null === (t = this.Dd()) || void 0 === t ? void 0 : t.open("Braze IndexedDB Support Test");

          if (e && (e.onupgradeneeded = function () {
            return e.result.close();
          }, e.onsuccess = function () {
            return e.result.close();
          }), "undefined" != typeof window) {
            var _t = window,
                _e = _t.chrome || _t.browser || _t.pd;

            if (_e && _e.runtime && _e.runtime.id) return this.vd.info("Not using IndexedDB for storage because we are running inside an extension"), !1;
          }

          return !0;
        }
      } catch (t) {
        return this.vd.info("Not using IndexedDB for storage due to following error: " + t), !1;
      }
    }
  }, {
    key: "Bd",
    value: function Bd(t, e) {
      var n;
      var o = null === (n = this.Dd()) || void 0 === n ? void 0 : n.open(this.database.Sd, this.database.VERSION);
      if (null == o) return "function" == typeof e && e(), !1;
      var i = this;
      return o.onupgradeneeded = function (t) {
        var e;
        i.vd.info("Upgrading indexedDB " + i.database.Sd + " to v" + i.database.VERSION + "...");
        var n = null === (e = t.target) || void 0 === e ? void 0 : e.result;

        for (var _t2 in i.database.Os) {
          var _e2 = _t2;
          i.database.Os.hasOwnProperty(_t2) && !n.objectStoreNames.contains(i.database.Os[_e2]) && n.createObjectStore(i.database.Os[_e2]);
        }
      }, o.onsuccess = function (n) {
        var o;
        var r = null === (o = n.target) || void 0 === o ? void 0 : o.result;
        r.onversionchange = function () {
          r.close(), "function" == typeof e && e(), i.vd.error("Needed to close the database unexpectedly because of an upgrade in another tab");
        }, t(r);
      }, o.onerror = function (t) {
        var n;
        var o = t;
        return i.vd.info("Could not open indexedDB " + i.database.Sd + " v" + i.database.VERSION + ": " + (null === (n = o.target) || void 0 === n ? void 0 : n.errorCode)), "function" == typeof e && e(), !0;
      }, !0;
    }
  }, {
    key: "setItem",
    value: function setItem(t, e, n, o, i) {
      if (!this.isSupported()) return "function" == typeof i && i(), !1;
      var r = this;
      return this.Bd(function (d) {
        if (!d.objectStoreNames.contains(t)) return r.vd.error("Could not store object " + e + " in " + t + " on indexedDB " + r.database.Sd + " - " + t + " is not a valid objectStore"), "function" == typeof i && i(), void d.close();
        var s = d.transaction([t], "readwrite");

        s.oncomplete = function () {
          return d.close();
        };

        var u = s.objectStore(t).put(n, e);
        u.onerror = function () {
          r.vd.error("Could not store object " + e + " in " + t + " on indexedDB " + r.database.Sd), "function" == typeof i && i();
        }, u.onsuccess = function () {
          "function" == typeof o && o();
        };
      }, i);
    }
  }, {
    key: "getItem",
    value: function getItem(t, e, n) {
      if (!this.isSupported()) return !1;
      var o = this;
      return this.Bd(function (i) {
        if (!i.objectStoreNames.contains(t)) return o.vd.error("Could not retrieve object " + e + " in " + t + " on indexedDB " + o.database.Sd + " - " + t + " is not a valid objectStore"), void i.close();
        var r = i.transaction([t], "readonly");

        r.oncomplete = function () {
          return i.close();
        };

        var d = r.objectStore(t).get(e);
        d.onerror = function () {
          o.vd.error("Could not retrieve object " + e + " in " + t + " on indexedDB " + o.database.Sd);
        }, d.onsuccess = function (t) {
          var e;
          var o = null === (e = t.target) || void 0 === e ? void 0 : e.result;
          null != o && n(o);
        };
      });
    }
  }, {
    key: "jr",
    value: function jr(t, e, n) {
      if (!this.isSupported()) return "function" == typeof n && n(), !1;
      var o = this;
      return this.Bd(function (i) {
        if (!i.objectStoreNames.contains(t)) return o.vd.error("Could not retrieve last record from " + t + " on indexedDB " + o.database.Sd + " - " + t + " is not a valid objectStore"), "function" == typeof n && n(), void i.close();
        var r = i.transaction([t], "readonly");

        r.oncomplete = function () {
          return i.close();
        };

        var d = r.objectStore(t).openCursor(null, "prev");
        d.onerror = function () {
          o.vd.error("Could not open cursor for " + t + " on indexedDB " + o.database.Sd), "function" == typeof n && n();
        }, d.onsuccess = function (t) {
          var o;
          var i = null === (o = t.target) || void 0 === o ? void 0 : o.result;
          null != i && null != i.value && null != i.key ? e(i.key, i.value) : "function" == typeof n && n();
        };
      }, n);
    }
  }, {
    key: "me",
    value: function me(t, e) {
      if (!this.isSupported()) return !1;
      var n = this;
      return this.Bd(function (o) {
        if (!o.objectStoreNames.contains(t)) return n.vd.error("Could not delete record " + e + " from " + t + " on indexedDB " + n.database.Sd + " - " + t + " is not a valid objectStore"), void o.close();
        var i = o.transaction([t], "readwrite");

        i.oncomplete = function () {
          return o.close();
        };

        i.objectStore(t)["delete"](e).onerror = function () {
          n.vd.error("Could not delete record " + e + " from " + t + " on indexedDB " + n.database.Sd);
        };
      });
    }
  }, {
    key: "Hs",
    value: function Hs(t, e) {
      if (!this.isSupported()) return !1;
      var n = this;
      return this.Bd(function (o) {
        if (!o.objectStoreNames.contains(t)) return n.vd.error("Could not retrieve objects from " + t + " on indexedDB " + n.database.Sd + " - " + t + " is not a valid objectStore"), void o.close();
        var i = o.transaction([t], "readwrite");

        i.oncomplete = function () {
          return o.close();
        };

        var r = i.objectStore(t),
            d = r.openCursor(),
            s = [];
        d.onerror = function () {
          s.length > 0 ? (n.vd.info("Cursor closed midway through for " + t + " on indexedDB " + n.database.Sd), e(s)) : n.vd.error("Could not open cursor for " + t + " on indexedDB " + n.database.Sd);
        }, d.onsuccess = function (t) {
          var n;
          var o = null === (n = t.target) || void 0 === n ? void 0 : n.result;

          if (null != o) {
            if (null != o.value && null != o.key) {
              r["delete"](o.key).onsuccess = function () {
                s.push(o.value);
              };
            }

            "function" == typeof o["continue"] && o["continue"]();
          } else s.length > 0 && e(s);
        };
      });
    }
  }, {
    key: "clearData",
    value: function clearData() {
      if (!this.isSupported()) return !1;
      var t = [];

      for (var _e3 in this.database.Os) {
        var n = _e3;
        this.database.Os.hasOwnProperty(_e3) && this.database.Os[n] !== this.database.Os.ie && t.push(this.database.Os[n]);
      }

      var e = this;
      return this.Bd(function (n) {
        var o = n.transaction(t, "readwrite");

        o.oncomplete = function () {
          return n.close();
        };

        for (var _n = 0; _n < t.length; _n++) {
          var i = t[_n];

          o.objectStore(i).clear().onerror = function () {
            e.vd.error("Could not clear " + this.source.name + " on indexedDB " + e.database.Sd);
          };
        }

        o.onerror = function () {
          e.vd.error("Could not clear object stores on indexedDB " + e.database.Sd);
        };
      });
    }
  }]);

  return it;
}();

export { it as default };
it.Gs = {
  _s: {
    Sd: "AppboyServiceWorkerAsyncStorage",
    VERSION: 6,
    Os: {
      Xu: "data",
      hr: "pushClicks",
      cu: "pushSubscribed",
      Cd: "fallbackDevice",
      Ks: "cardUpdates",
      ie: "optOut",
      $r: "pendingData",
      yh: "sdkAuthenticationSignature"
    },
    oe: 1
  }
};